import { create } from 'zustand';

interface SceneStore {
  /** 0..100 during asset load (UI-01 progress bar reads this). */
  loadProgress: number;
  /** Currently active era; drives material/visibility swap in Phase 4. */
  era: '1925' | '2026';
  /** ID of the currently-focused manifest object (null = none). */
  selectedObjectId: string | null;
  /** True once /manifest/world.json has loaded and validated. */
  manifestLoaded: boolean;
  /**
   * ID of the vista zone the camera is currently inside (null = not in any zone).
   * Phase 4 Plan 01 contract; Wave 3's EraToggle UI reads this to gate visibility.
   */
  currentVistaId: string | null;
  /**
   * True while the 400ms era opacity crossfade is mid-tween. Phase 4 Plan 01
   * contract; Wave 2 EraGroup flips this; Wave 3 EraToggle disables during transitions.
   */
  eraTransitioning: boolean;
  setLoadProgress: (p: number) => void;
  setEra: (e: '1925' | '2026') => void;
  setSelectedObjectId: (id: string | null) => void;
  setManifestLoaded: (b: boolean) => void;
  setCurrentVistaId: (id: string | null) => void;
  setEraTransitioning: (b: boolean) => void;
}

export const useSceneStore = create<SceneStore>((set) => ({
  loadProgress: 0,
  era: '1925',
  selectedObjectId: null,
  manifestLoaded: false,
  currentVistaId: null,
  eraTransitioning: false,
  setLoadProgress: (loadProgress) => set({ loadProgress }),
  setEra: (era) => set({ era }),
  setSelectedObjectId: (selectedObjectId) => set({ selectedObjectId }),
  setManifestLoaded: (manifestLoaded) => set({ manifestLoaded }),
  setCurrentVistaId: (currentVistaId) => set({ currentVistaId }),
  setEraTransitioning: (eraTransitioning) => set({ eraTransitioning }),
}));
